import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMoreHorizontal, FiLink, FiTag } from 'react-icons/fi';

const NoteCard = ({ note, onDragEnd, isGraphView }) => {
  if (isGraphView) return null; // Handled by ECharts in graph view

  const getTypeStyles = (type) => {
    switch (type) {
      case 'core': return 'border-maple shadow-maple/20 ring-1 ring-maple/30';
      case 'insight': return 'border-ink shadow-ink/10 ring-1 ring-ink/10';
      default: return 'border-paper-dark shadow-sm';
    }
  };

  return (
    <motion.div
      drag
      dragMomentum={false}
      onDragEnd={(e, info) => onDragEnd(note.id, info)}
      initial={{ x: note.x, y: note.y, opacity: 0, scale: 0.9 }}
      animate={{ x: note.x, y: note.y, opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      className={`absolute w-72 bg-paper-light rounded-xl p-5 cursor-grab active:cursor-grabbing hover:shadow-lg transition-shadow border-2 ${getTypeStyles(note.type)} z-10`}
      style={{ touchAction: 'none' }}
    >
      <div className="flex justify-between items-start mb-3">
        <h3 className="font-semibold text-ink leading-tight pr-4">{note.title}</h3>
        <button className="text-ink-muted hover:text-maple transition-colors">
          <SafeIcon icon={FiMoreHorizontal} />
        </button>
      </div>
      
      <p className="text-sm text-ink-light mb-4 line-clamp-4 leading-relaxed">
        {note.content}
      </p>

      <div className="flex items-center justify-between mt-auto pt-3 border-t border-paper-dark">
        <div className="flex gap-1.5 flex-wrap">
          {note.tags.map((tag, idx) => (
            <span key={idx} className="inline-flex items-center text-[10px] uppercase tracking-wider font-semibold bg-maple-soft text-maple px-2 py-1 rounded-md">
              {tag}
            </span>
          ))}
        </div>
        <div className="flex gap-2 text-ink-muted">
          <SafeIcon icon={FiLink} className="w-3.5 h-3.5" />
        </div>
      </div>
    </motion.div>
  );
};

export default NoteCard;